import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Box, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import { useInputState } from 'lib/useInputState';
import { ButtonV2 } from '../ui/PayButton';

const PREFIX = 'PayOrderNoteDialog';

const classes = {
    title: `${PREFIX}title`
};

const StyledBox = styled(Box)(({ theme }) => ({
    width: '100%',
    overflow: 'hidden',
    [`& .${classes.title}`]: {
        textAlign: 'center',
        width: '100%',
        fontFamily: `TenantFont, ${theme.typography.fontFamily}`,
        fontWeight: 'bold',
        color: theme.palette.titleTextColour
    }
}));

interface PayOrderNoteDialogProps {
    title: string;
    description: string;
    initialValue?: string;
    onChange: (title: string, value: string) => void;
}

export const PayOrderNoteDialog: React.FC<React.PropsWithChildren<PayOrderNoteDialogProps>> = ({
    title,
    onChange,
    initialValue,
    description
}) => {
    const { t } = useTranslation();
    const [value, handleChange] = useInputState(initialValue ?? '');
    const handleSave = React.useCallback(() => {
        onChange(title, value);
    }, [value, onChange, title]);
    const handleKeyPress = React.useCallback(
        (e: React.KeyboardEvent) => {
            if (e.key === 'Enter') {
                handleSave();
            }
        },
        [handleSave]
    );
    return (
        <StyledBox>
            <Grid container spacing={3}>
                <Grid size={12}>
                    <Typography variant="h6" className={classes.title} align="center">
                        {title}
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <TextField
                        autoFocus
                        value={value}
                        onChange={handleChange}
                        onKeyDown={handleKeyPress}
                        label={description}
                        variant="outlined"
                        fullWidth
                        color="secondary"
                    />
                </Grid>
                <Grid size={12}>
                    <ButtonV2 variant="contained" color="primary" onClick={handleSave} fullWidth>
                        {t('BASKET_ORDER_NOTES_SAVE')}
                    </ButtonV2>
                </Grid>
            </Grid>
        </StyledBox>
    );
};
